import { Action, createReducer, on } from '@ngrx/store';

import { FlightType } from '@search-bar/entities/flight-type';
import { selectFlightTypeAction } from '../actions/search-bar.actions';
import { loadSearchDataSuccessAction } from '@shared/base-search-bar/store/actions/storage.actions';
import { BusType } from '@search-bar/entities/bus-type';

export const initialState = FlightType.ROUNDTRIP as FlightType | BusType;

const reducer = createReducer(
  initialState,
  on(selectFlightTypeAction, (state, { flightType }) => {
    return flightType;
  }),
  on(loadSearchDataSuccessAction, (state, { data }) => data ? data.flightType : initialState)
);

export function flightTypeReducer(state: FlightType | BusType, action: Action): FlightType | BusType {
  return reducer(state, action);
}
